import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import CharacterClassIcon from 'app/frontend/base/components/CharacterClassIcon'
import { classColours } from 'app/frontend/types/custom/CharacterClass'
import { UserRound } from 'lucide-react'
import type { RelevantCharacter } from './types'

const CharacterLabel = ({ character }: { character: RelevantCharacter }) => {
  const className = character.characterClass
    ? classColours[character.characterClass].text
    : ''

  return (
    <div className='flex items-center gap-2'>
      <CharacterClassIcon
        size='medium'
        characterClass={character.characterClass}
      />
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={className}>{character.name}</span>
        </TooltipTrigger>
        <TooltipContent>
          <div className='flex flex-col gap-1'>
            {character.rankInGuild !== undefined ? (
              <div>
                <span className='mr-2 font-bold opacity-50'>Rank:</span>
                <span>{character.rankInGuild}</span>
              </div>
            ) : (
              <div className='italic opacity-50'>
                Sync your guild data with the desktop client to see more
                information
              </div>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
      {character.inTeam ? null : (
        <Tooltip>
          <TooltipTrigger asChild>
            <UserRound className='h-4 w-4 text-warning-foreground' />
          </TooltipTrigger>
          <TooltipContent>Guest (not in team)</TooltipContent>
        </Tooltip>
      )}
    </div>
  )
}

export default CharacterLabel
